export enum PLOT_DIVS {
  TIMESERIES = 'timeseries_plot',
  SCATTER = 'scatter_plot',
  HISTOGRAM = 'histogram_plot',
}
